import { ID } from "common/entities/IEntity";
import { Type } from "common/entities/IMessage";
import { Entity, Field } from "typegraph";

export interface IArticleSavedSearchParams {
	type?: Type;
}

@Entity({
	one: "article_saved_search_many",
	create: "article_saved_search_one_create",
	many: "article_saved_search_many",
	update: "article_saved_search_one_update"
})
export class ArticleSavedSearch {
	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public description?: string;

	@Field()
	public query: string;
}



// WEBPACK FOOTER //
// ./src/panels/saveSearch/entities/ArticleSavedSearch.ts